/* eslint-disable react/destructuring-assignment,prefer-destructuring,react/require-default-props,react/no-unused-prop-types,react/default-props-match-prop-types */

import $ from 'jquery';
import _ from 'lodash';

import React from 'react';
import PropTypes from 'prop-types';
import './RackspaceCdnFileUploader.scss';

import RESOURCE from '../../../resource/Resource';

import {
  transcodeOptions,
  VIDEO_TYPES,
  AUDIO_TYPES,
  DOCUMENT_TYPES,
} from '../Uploader/FileHelpers';

/**
 * This creates a hidden component which handles the uploading of files from
 * the client.
 *
 * Call this.selectFile() externally to trigger the file select + upload process.
 *
 * Call this.setFiles(fileList) externally to specifically process files without the select dialog
 *
 * Call this.startUploads(fileList?) externally to start the file transfers, often called in the setFiles
 *    callback. If a file list is given, it will set the state to that file list, otherwise
 *    it will get the files from the state.
 *
 * TODO: make this support multiple files
 * TODO: make this work with a dropzone
 * TODO: segment uploads
 */
export class RackspaceCdnFileUploader extends React.Component {
  state = {
    files: null,
  };

  constructor(props) {
    super(props);

    this.fileInputId = _.uniqueId('file-input-');
  }

  selectFile = () => {
    this.fileInput.click();
  };

  setFiles = (fileList) => {
    // We often get a FileList when calling setFiles. Convert it to an Array
    const fileArray = [...fileList];

    // Filter down files
    const files = fileArray.filter(this.props.filterFile);

    // Nothing interesting happened
    if (files.length === 0) {
      return;
    }

    this.setState({
      files,
    });
    this.props.onFilesSelected(files);
  };

  // API call that initiates the upload process. This supports the "upload on form submit" workflow used by comment attachments
  startUploads = (givenFiles, { shouldTranscode = false } = {}) => {
    let files = givenFiles;
    if (!files) {
      files = this.state.files;
    } else {
      this.setState({
        files,
      });
    }
    if (!files) {
      return false;
    }

    // Get upload URLs for each file
    this._createCdnFiles(files)
      .done((uploadUrls) => {
        // Begin uploading
        const dfrUploads = uploadUrls
          .map(this._uploadToCdn)
          .map(this._finalizeUpload(uploadUrls, shouldTranscode));
        const storageKeys = uploadUrls.map((info) => info.storageKey);

        // When they're all done ...
        $.when(...dfrUploads).done(() => {
          // Grab the download URLs
          this._getDownloadURL(storageKeys).done((downloadUrls) => {
            this.props.onUploadsCompleted(downloadUrls, storageKeys);
          });
        });
      })
      .fail((errMessage) => {
        this.props.onUploadFailed(errMessage);
      });
    return true;
  };

  onFileChange = (event) => {
    const input = event.target;
    this.setFiles(input.files);
    input.value = null;
  };

  // Create files
  _createCdnFiles = (files) => {
    const dfd = new $.Deferred();
    const params = {
      filenames: JSON.stringify(files.map((file) => file.name)),
    };

    RESOURCE.execute('upload', 'createFiles', params)
      .done((uploadUrls) => {
        dfd.resolve(uploadUrls);
      })
      .fail((response) => {
        dfd.reject(response);
      });

    return dfd;
  };

  _finalizeUpload = (uploadUrls, shouldTranscode) => (indexP) => {
    const dfd = new $.Deferred();
    indexP.done((index) => {
      const uploadUrl = uploadUrls[index];
      const file = this.state.files[index];

      let options = null;
      if (AUDIO_TYPES.indexOf(file.type) !== -1) {
        options = { audio: transcodeOptions.audio };
      } else if (VIDEO_TYPES.indexOf(file.type) !== -1) {
        options = { video: transcodeOptions.video, shouldTranscode };
      } else if (DOCUMENT_TYPES.indexOf(file.type) !== -1) {
        options = { document: transcodeOptions.document };
      }

      RESOURCE.execute('upload', 'finalizeUpload', {
        storageKey: uploadUrl.storageKey,
        options,
      }).done((response) => {
        dfd.resolve(response);
      });
    });

    return dfd;
  };

  _uploadToCdn = (uploadInfo, index) => {
    const file = this.state.files[index];
    const dfd = new $.Deferred();
    const xhr = new XMLHttpRequest();

    // File uploaded
    xhr.upload.addEventListener('load', () => {
      this.props.onFileUploaded(index, this.state.files[index]);
      dfd.resolve(index);
    });
    xhr.upload.addEventListener('progress', (e) => {
      const percentComplete = Math.ceil((e.loaded / e.total) * 100);
      this.props.onFileProgress(index, file, percentComplete);
    });

    // TODO: fail handler

    xhr.open('PUT', uploadInfo.uploadURL);

    xhr.setRequestHeader('Access-Control-Allow-Origin', '*');
    xhr.setRequestHeader(
      'Access-Control-Expose-Headers',
      'Access-Control-Allow-Origin'
    );
    xhr.setRequestHeader('x-ms-blob-type', 'BlockBlob');

    // Note:
    // There is no need to use FileReader.readAsDataURL to convert the File to a data URL
    // only to convert it back into a Blob. A File object is already a Blob and can be used in xhr.send().
    // Also FileReader.readAsDataURL will not work for large files like videos due to browsers limiting
    // the size of files that can be read into memory.
    xhr.overrideMimeType(file.type);
    xhr.send(file);

    return dfd;
  };

  _getDownloadURL = (storageKeys) => {
    const dfd = new $.Deferred();

    RESOURCE.lookup('upload', 'getDownloadURLs', { storageKeys }).done(
      (downloadUrls) => {
        const storageKeyLinks = downloadUrls.map((link, index) => {
          return {
            storageKey: storageKeys[index],
            link,
          };
        });
        dfd.resolve(storageKeyLinks);
      }
    );

    return dfd;
  };

  render() {
    return (
      <rackspace-cdn-file-uploader>
        <label className="file-input-label" htmlFor={this.fileInputId}>
          File
        </label>
        <input
          type="file"
          accept={this.props.acceptsFormats}
          className="file-input"
          ref={(el) => {
            this.fileInput = el;
          }}
          onChange={this.onFileChange}
          id={this.fileInputId}
        />
      </rackspace-cdn-file-uploader>
    );
  }
}

RackspaceCdnFileUploader.propTypes = {
  // Lets you restrict file types
  acceptsFormats: PropTypes.string,
  filterFile: PropTypes.func.isRequired, // (file) > return True/False to accept each file
  onFilesSelected: PropTypes.func.isRequired, // (files)
  onFileProgress: PropTypes.func.isRequired, // (index, file, percentage)
  onProgress: PropTypes.func.isRequired, // TODO: (percentage) > Total progress
  onFileUploaded: PropTypes.func.isRequired, // (index, file) > file has finished uploading
  onUploadFailed: PropTypes.func.isRequired, // TODO: (index, file) > file failed to upload
  onUploadsCompleted: PropTypes.func.isRequired, // (downloadUrls) > all uploads have finished
};

RackspaceCdnFileUploader.defaultProps = {
  filterFile: () => true, // Default: accept all files
  onFilesSelected: () => {},
  onFileProgress: () => {},
  onProgress: () => {},
  onFileUploaded: () => {},
  onUploadFailed: () => {},
  onUploadsCompleted: () => {},
};
